import * as auto from './exportI18n-zh'

export default {
  login: require('./login'),
  store: require('./store'),
  common: require('./common'),
  product: require('./product'),
  order: require('./order'),
  ...require('@smallwei/avue'),
  ...auto.Inject(auto)
}
